import React from "react";
import { Row, Col, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ListPermissions } from "./permissionsList/ListPermissions";
import { ACL } from '../../../../../config/constants';


function GroupPermissionsTab(props) {
  const {
    permissionsInGroup,
    permissionsNotInGroup,
    updatePermissions,
    submitPermissions,
  } = props;

  const addPermissionToGroup = (permission, index) => {
    if (! ACL.ADMIN.GROUPS.SYNC_ACLS.hasAccess()) {
      return;
    }

    let clonePermissionsInGroup = [ ...permissionsInGroup ];
    let clonePermissionsNotInGroup = [ ...permissionsNotInGroup ];

    clonePermissionsNotInGroup.splice( index, 1 );
    clonePermissionsInGroup.push( permission );

    updatePermissions( clonePermissionsInGroup, clonePermissionsNotInGroup );
  }

  const removePermissionFromGroup = (permission, index) => {
    if (! ACL.ADMIN.GROUPS.SYNC_ACLS.hasAccess()) {
      return;
    }

    let clonePermissionsInGroup = [ ...permissionsInGroup ];
    let clonePermissionsNotInGroup = [ ...permissionsNotInGroup ];

    clonePermissionsInGroup.splice( index, 1 );
    clonePermissionsNotInGroup.push( permission );

    updatePermissions( clonePermissionsInGroup, clonePermissionsNotInGroup );
  }

  return (
    <div className="admin-group-detail-section admin-group-detail-section--permissions">
          <Row className="admin-group-detail-permissions-row">
            <Col md="6" className="admin-group-detail-permissions-column pr-md-2"
                 data-testid="permissions_admin_not_in_group">
              <Row className="justify-content-center mt-2 text-center">
                <h4><FormattedMessage
                  id="components.admin.tabs.group_permissions_tab.permissions_admin_not_in_group"/>
                </h4>
              </Row>
              <ListPermissions
                permissions={permissionsNotInGroup}
                addPermissionToGroup={addPermissionToGroup}
                permissionType={"admin"}
              />
            </Col>
            <Col md="6" className="admin-group-detail-permissions-column pl-md-2" data-testid="permissions_admin_in_group">
              <Row className="justify-content-center mt-2 text-center">
                <h4><FormattedMessage
                  id="components.admin.tabs.group_permissions_tab.permissions_admin_in_group"/>
                </h4>
              </Row>
              <ListPermissions
                permissions={permissionsInGroup}
                removePermissionFromGroup={removePermissionFromGroup}
                displayPermissionsGroup={true}
                permissionType={"admin"}
              />
            </Col>
          </Row>
          <Row className="admin-group-detail-permissions-row">
            <Col md="6" className="admin-group-detail-permissions-column pr-md-2"
                 data-testid="permissions_client_not_in_group">
              <Row className="justify-content-center mt-2 text-center">
                <h4><FormattedMessage
                  id="components.admin.tabs.group_permissions_tab.permissions_client_not_in_group"/>
                </h4>
              </Row>
              <ListPermissions
                permissions={permissionsNotInGroup}
                addPermissionToGroup={addPermissionToGroup}
                permissionType={"client"}
              />
            </Col>
            <Col md="6" className="admin-group-detail-permissions-column pl-md-2" data-testid="permissions_client_in_group">
              <Row className="justify-content-center mt-2 text-center">
                <h4><FormattedMessage
                  id="components.admin.tabs.group_permissions_tab.permissions_client_in_group"/>
                </h4>
              </Row>
              <ListPermissions
                permissions={permissionsInGroup}
                removePermissionFromGroup={removePermissionFromGroup}
                displayPermissionsGroup={true}
                permissionType={"client"}
              />
            </Col>
          </Row>
          <Row className="admin-group-detail-section__actions">
            {ACL.ADMIN.GROUPS.SYNC_ACLS.hasAccess() && <Col className="text-right py-3">
              <Button id="button.create"
                      color="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        submitPermissions();
                      }}
              >
                <FormattedMessage id="button.save"/>
              </Button>
            </Col>}
          </Row>
    </div>
  );
}

export { GroupPermissionsTab }
